
export default {
  namespaced: true,
  state () {
    return {
      vnNoInfo: [
        {
          title: 'Không có thông tin',
          content: 'Không có thông tin về trang này ! Quay về ',
          link: 'Trang chủ'
        }
      ],
      enNoInfo: [
        {
          title: 'No infomation',
          content: 'There is no information about this page ! Return ',
          link: 'Home'
        }
      ]
    }
  },
  getters: {
    finalNoInfo (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnNoInfo
      } else {
        return state.enNoInfo
      }
    }
  }
}
